@if (!loading) {
  @if (!!_dataSource.data.length) {
    <ng-container class="table-responsive">
      <mat-table
        (matSortChange)="sortChanged($event)"
        [dataSource]="_dataSource"
        class="width-match-parent"
        matSort
        >
        @for (column of displayedColumns; track column) {
          <ng-container [matColumnDef]="column">
            <mat-header-cell
              *matHeaderCellDef
              [disabled]="cellTemplates.get(column)?.sortingDisabled"
              [fxHide.lt-md]="(column | fn: get).hideLtMd"
              [fxHide.lt-sm]="(column | fn: get).hideLtSm || (column | fn: get).hideLtMd"
              mat-sort-header
              rememberSort
              >
              {{ cellTemplates.get(column)?.columnTitle ?? '' | translate | uppercase }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [fxHide.lt-md]="(column | fn: get).hideLtMd"
              [fxHide.lt-sm]="(column | fn: get).hideLtSm || (column | fn: get).hideLtMd"
              >
              <ng-container [ngTemplateOutletContext]="{ $implicit: row }"
                [ngTemplateOutlet]="cellTemplates.get(column)?.templateRef ?? null"
               />
            </mat-cell>
          </ng-container>
        }
        <mat-header-row *matHeaderRowDef="displayedColumns" />
        <mat-row (click)="onRowClick(row, $event)"
          (contextmenu)="onRightClick(row, $event)"
          *matRowDef="let row; columns: displayedColumns"
          [class.hover]="showHover"
          [class.pointer]="showHover"
        [ngClass]="{
          highlight: highlightedRowsId === row.id || this.selectedRows.has(row),
          'fade-out': highlightedRowsId === row.id
        }"
         />
      </mat-table>
    </ng-container>
  } @else {
    <recrewt-empty-page (buttonClick)="emptyClick.emit()" [config]="empty" />
  }
} @else {
  <div class="m-t-3 p-h-3">
    <div class="m-b-2">
      <ngx-skeleton-loader [theme]="{ height: '12px' }" />
    </div>
    @for (i of 6 | iterable; track i) {
      <div fxLayout="column" style="height: 40px">
        <ngx-skeleton-loader [theme]="{ marginBottom: '4px', padding: 0 }" />
      </div>
    }
  </div>
}
<div [hidden]="!_dataSource.data.length || loading">
  <mat-paginator [hidePageSize]="true" [pageSize]="20" />
</div>


